import { render, staticRenderFns } from "./MinhasComprasDiretasFrase.vue?vue&type=template&id=e2f1142e&scoped=true"
import script from "./MinhasComprasDiretasFrase.vue?vue&type=script&lang=js"
export * from "./MinhasComprasDiretasFrase.vue?vue&type=script&lang=js"
import style0 from "./MinhasComprasDiretasFrase.vue?vue&type=style&index=0&id=e2f1142e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f1142e",
  null
  
)

export default component.exports